import type { Film, Preview } from "./types";

/** Previews still to render. Each is a version of its own; a rendered one
 * gives way to its video. */
export const unrendered = (films: Film[], previews: Preview[]) =>
  previews.filter((v) => !films.some((f) => f.id === v.render.filmId));
